export default __webpack_public_path__ + "static/media/ic-previous-test.cb6e05ca.svg";